var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComments = function SvgComments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.98 11.29V15.29C17.98 15.55 17.97 15.8 17.94 16.04C17.71 18.74 16.12 20.08 13.19 20.08H12.79C12.54 20.08 12.3 20.2 12.15 20.4L10.95 22C10.42 22.71 9.56 22.71 9.03 22L7.82999 20.4C7.69999 20.23 7.41 20.08 7.19 20.08H6.79001C3.60001 20.08 2 19.29 2 15.29V11.29C2 8.36001 3.35001 6.77001 6.04001 6.54001C6.28001 6.51001 6.53001 6.5 6.79001 6.5H13.19C16.38 6.5 17.98 8.10001 17.98 11.29Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99023 14.5C9.43023 14.5 8.99023 14.05 8.99023 13.5C8.99023 12.95 9.44023 12.5 9.99023 12.5C10.5402 12.5 10.9902 12.95 10.9902 13.5C10.9902 14.05 10.5502 14.5 9.99023 14.5Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4902 14.5C12.9302 14.5 12.4902 14.05 12.4902 13.5C12.4902 12.95 12.9402 12.5 13.4902 12.5C14.0402 12.5 14.4902 12.95 14.4902 13.5C14.4902 14.05 14.0402 14.5 13.4902 14.5Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.5C5.94 14.5 5.5 14.05 5.5 13.5C5.5 12.95 5.95 12.5 6.5 12.5C7.05 12.5 7.5 12.95 7.5 13.5C7.5 14.05 7.05 14.5 6.5 14.5Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9791 7.29001V11.29C21.9791 14.23 20.6291 15.81 17.9391 16.04C17.9691 15.8 17.9791 15.55 17.9791 15.29V11.29C17.9791 8.10001 16.3791 6.5 13.1891 6.5H6.78906C6.52906 6.5 6.27906 6.51001 6.03906 6.54001C6.26906 3.85001 7.85906 2.5 10.7891 2.5H17.1891C20.3791 2.5 21.9791 4.10001 21.9791 7.29001Z",
    fill: "#292D32"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comments.bf854028.svg";
export { ForwardRef as ReactComponent };